<template>
<form id="zipReportgeneration" method="post">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="passwordModalLabel">Generate Zipcode Report</h5>

            <button type="button" class="btn-close" @click="$emit('closeModal')"></button>
          </div>
          <div class="modal-body">
            <div class="form-group" :class="{ error: v$.form.zipcode.$errors.length }">
              <label class="small mb-1">Enter Zipcode</label>
              <input type="number" class="form-control py-4" name="zipcode" v-model="v$.form.zipcode.$model" v-maska data-maska="#####" />
              <div class="input-errors" v-for="(error, index) of v$.form.zipcode.$errors" :key="index">
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" @click="$emit('closeModal')">Cancel</button>
            <button type="button" class="btn btn-primary" @click.prevent="processZipReport()">Submit</button>
          </div>
        </div>
      </form>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import { vMaska } from 'maska';
import { required } from '@vuelidate/validators';
import axios from 'axios';
export default {
  name: 'GenerateZipDataset',
  setup () {
    return {
        v$: useVuelidate()
    }
  },
  directives: { maska: vMaska },
  data () {
    return {
      form: {
        zipcode: ''
      }
    }
  },
  validations () {
    return {
        form: {
            zipcode: { required }
        }
    }
  },
  props: {},
  methods: {
    processZipReport(event) {
      let formData = new FormData();
      formData.append('zipcode', this.form.zipcode);
      axios({
        method: "POST",
        url: "/mashup_from_zip",
        data: formData
      })
      .then(
			(response) => {
        console.log(response);
        this.$emit('closeModal');
      })
      .catch(
			(error) => {
        console.log(error);
        console.log('form submit failed');
      })
    }
    
  }
}
</script>